<template>
  <Page>
    <template #header>
      <PerformanceDashboardHeader class="mb-4" />
    </template>
    <div class="relative w-full">
      <div class="absolute w-full">
        <PageLoader v-if="dashboardLoading" style="width: 418px">
          <template #body>
            <div class="loader-body">
              <DashboardLoader class="loader-img" />
              <div>Creating a custom dashboard for you...</div>
            </div>
          </template>
        </PageLoader>
      </div>
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4"
      data-cy="performance-dashboard-page"
    >
      <div class="flex flex-col gap-4 md:max-h-[75svh] overflow-auto">
        <PerformanceSummary class="performance-summary-widget mb-2" />
        <RevenueChart class="chart-widget mb-2" data-cy="revenue-chart" />
        <MembershipsSoldChart
          class="chart-widget mb-2"
          data-cy="memberships-sold-chart"
        />
        <OpportunitiesChart
          class="chart-widget mb-2"
          data-cy="opportunities-chart"
        />
      </div>
      <div class="">
        <TechLeaderboardWrapper class="tech-leaderboard-widget" />
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import PageLoader from "@/components/PageLoader.vue";
import DashboardLoader from "@/images/dashboard-loader.svg?component";
import Page from "../components/Page.vue";
import PerformanceDashboardHeader from "./PerformanceDashboardHeader.vue";
import PerformanceSummary from "./PerformanceSummary.vue";
import TechLeaderboardWrapper from "./TechLeaderboardWrapper.vue";
import MembershipsSoldChart from "./Widgets/MembershipsSoldChart.vue";
import OpportunitiesChart from "./Widgets/OpportunitiesChart.vue";
import RevenueChart from "./Widgets/RevenueChart.vue";

const store = useStore();
const dashboardLoading = computed(() => store.state.dashboardLoading);

onBeforeUnmount(() => {
  store.dispatch("clearDashboardData");
});
</script>

<style lang="scss" scoped>
.left-col {
  width: 45%;
  margin-right: 5px;
}
.right-col {
  width: 55%;
  margin-left: 5px;
}
.chart-widget {
  min-height: 280px;
}
.tech-leaderboard-widget {
  flex: 2;
  position: relative;
}

.loader-img {
  height: 180px;
  margin: 20px 0;
}

.loader-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
